export function GrainOverlay() {
  return <div className="grain-overlay" aria-hidden="true" />;
}

export function Overline({ children, className = "" }) {
  return (
    <span className={`inline-block uppercase text-[11px] tracking-[0.35em] font-medium text-gold-500 ${className}`}>
      {children}
    </span>
  );
}

export function SectionHeading({ overline, title, className = "", light }) {
  return (
    <div className={className}>
      {overline && <Overline className="mb-5">{overline}</Overline>}
      <h2 className={`font-serif tracking-tight leading-[0.95] text-4xl md:text-5xl lg:text-6xl ${light ? "text-white" : "text-white"}`}>
        {title}
      </h2>
    </div>
  );
}

export function GoldRule({ className = "" }) {
  return <div className={`h-px w-full bg-gradient-to-r from-gold-500/50 via-gold-500/15 to-transparent ${className}`} />;
}
